import React from "react";
import { Modal } from "react-bootstrap";
import imageDelayWaiting from "../Images/waiting.png";

function ModalDisbursalDelay(prop) {
    const {modalState, setModalState} = prop
    if(modalState){

    }

    const nbfcName = localStorage.getItem("nbfcName");
    // console.log(nbfcName, "gghjgjhghj");
    
    const fnModal = () =>{
      //console.log("click")
        }
  return (
    <div
      className="modalFail"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <Modal
        className="modalDisbursal"
        style={{
          display: "flex !important",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
        show={modalState}
      >
        <div className="modalContainer">
          <img
            className="imageImgnew"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin:"auto"
            }}
            height="139"
            width="131"
            src={imageDelayWaiting}
          />
          
         <span className="modalSpan" style={{}}>
            Loan Disbursal Delayed
          </span>
       

          <div className="rightArrowBox">
            <span className="fontweit">
            We're coordinating with your assigned NBFC  
            <span className="bolderr">{nbfcName} </span> to expedite your loan disbursal and will make every effort to ensure it's processed as quickly as possible.
            </span>
            
          <br/>
            <p className="sidePoint">
              
              <span className="delayCenterText">Please sit back and relax.</span>
            </p>
          </div>

          <div onClick={()=>{fnModal();setModalState(false)}} className="okayButton">Okay</div>
        </div>
      </Modal>
    </div>
  );
}

export default ModalDisbursalDelay;
